module.exports = __webpack_public_path__ + "static/media/trieste-6.e5f3cb66.jpg";